import { MessageModel } from './MessageModel'

export default class ChatSessionModel {
  constructor (data = {}) {
    this.id = data.id || null
    this.agentId = data.agentId || null
    this.agentName = data.agentName || ''
    this.title = data.title || 'New Chat'
    this.messageCount = data.messageCount || 0
    this.createdAt = data.createdAt || null
    this.lastMessageAt = data.lastMessageAt || null
    this.lastMessagePreview = data.lastMessagePreview || ''
    this.messages = data.messages || []
  }

  loadModel (sessionData) {
    this.id = sessionData.id
    this.agentId = sessionData.agentId
    this.agentName = sessionData.agentName
    this.title = sessionData.title
    this.messageCount = sessionData.messageCount
    this.createdAt = sessionData.createdAt
    this.lastMessageAt = sessionData.lastMessageAt
    this.lastMessagePreview = sessionData.lastMessagePreview

    // Load messages if provided
    if (sessionData.messages && Array.isArray(sessionData.messages)) {
      this.messages = sessionData.messages.map(msg => new MessageModel(msg))
    }
  }

  toCreateDto () {
    return {
      agentId: this.agentId,
      title: this.title
    }
  }

  getRelativeTime () {
    if (!this.lastMessageAt) return 'Never'

    const now = new Date()
    const lastMsg = new Date(this.lastMessageAt)
    const diffMs = now - lastMsg
    const diffMins = Math.floor(diffMs / 60000)
    const diffHours = Math.floor(diffMs / 3600000)
    const diffDays = Math.floor(diffMs / 86400000)

    if (diffMins < 1) return 'Just now'
    if (diffMins < 60) return `${diffMins} min ago`
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`

    return lastMsg.toLocaleDateString()
  }
}
